  var deliveryData = {};

  document.addEventListener('DOMContentLoaded', function() {
    var deliveryDataElm = document.querySelectorAll('.script-item-delivery-data');
    for(elm of deliveryDataElm) {
      deliveryData[elm.dataset.itemid] = elm.dataset.deliverydata;
    }
  });
  
  document.addEventListener('updateQuantityComplete', (event) => {
    fetch('/cart.js')
      .then(response => response.json())
      .then(data => {
        var newDeliveryDate = null;
        
        for(item of data.items) {

          // 別画面で商品を追加した場合にはリロードを行う
          // 別画面で商品を追加し、元カート画面で数量を操作した場合に追加した出現する為
          if (deliveryData[item["product_id"]] == undefined) {
            location.reload();
            return;
          }

          if (newDeliveryDate == null) {
            newDeliveryDate = deliveryData[item["product_id"]];
          } else {
            const dateA = new Date(newDeliveryDate);
            const dateB = new Date(deliveryData[item["product_id"]]);
            
            if (dateA < dateB) {
              newDeliveryDate = deliveryData[item["product_id"]]
            }
          }
        }

        if (newDeliveryDate == "") newDeliveryDate = "19700101";
        
        let scriptInputDeliveryDate = document.getElementById("script-input-delivery-date");
        scriptInputDeliveryDate.value = newDeliveryDate;
      })
      .catch((error) => {
        console.log(error);
        window.alert('エラーが発生しました。ページを再読み込み（更新）してください');
      });
    
  });